  <div class="rating-bar">
    <span class="{{cssClass}}" [ngStyle]="{'width': percentage + '%'}">{{percentage}}%</span>
  </div>


// WEBPACK FOOTER //
// ./src/app/components/_shared/rating-bar/rating-bar.component.html